<template>
  <div style="height: 100%">
    <v-select
      v-if="show"
      :class="`${dirtyClass} pl-1 ma-0 soil-layer-drop-down`"
      :items="disabledItems"
      hide-selected
      item-value="id"
      item-title="text"
      density="compact"
      style="border-radius: 0; font-size: 14px"
      v-model="propModel"
      item-disabled="disabled"
      hide-details
      solo
      variant="plain"
    >
    </v-select>
  </div>
</template>
<script>
import { mapActions } from 'vuex'

export default {
  name: 'DropDownSoilLayerSelect',
  props: {
    options: {},
    item: { required: true },
    show: {},
    dirtyClass: { required: false },
    usedItems: {},
    name: {},
    parameter: { required: true },
    selectedSoilLayer: { required: true }
  },
  data: () => ({}),
  computed: {
    disabledItems() {
      this.options.forEach((ref) => {
        let index = this.usedItems.findIndex((usedRef) => {
          return ref.id === usedRef
        })
        ref.disabled = index >= 0
        ref.text = this.getName(ref.properties.base_soil_type)
      })
      return this.options
    },
    propModel: {
      get() {
        return this.getItem(this.selectedSoilLayer)
      },
      set(value) {
        this.setParameter({
          item: this.item,
          value: value,
          parameter: this.parameter
        })
        this.$emit('update')
      }
    }
  },
  methods: {
    ...mapActions('statePoints', {
      setParameter: 'setNestedParameter'
    }),
    getItem(id) {
      return this.options.find((item) => id === item.id)
    },
    getName(id) {
      let soilType = this.name ? this.name.find((item) => id === item.id) : null
      return soilType ? soilType['name'] : null
    }
  }
}
</script>
<style scoped>
.soil-layer-drop-down :deep(.v-select__selection--disabled) {
  color: black !important;
}
.soil-layer-drop-down {
  border-radius: unset;
}
:deep(.v-input__slot) {
  padding-left: unset !important;
  padding-right: unset !important;
}

:deep(.v-field__append-inner) {
  padding-top: 4px !important;
}
</style>
